import { SbBlokData, storyblokEditable } from "gatsby-source-storyblok"

import ArticleSuggestionSection from "../../../V2/Sections/ArticleSuggestionSection"

import React from "react"

const StoryblokArticleSuggestionSection = ({
  blok,
}: Storyblok.BlokProps<SbBlokData>) => {
  return <ArticleSuggestionSection {...storyblokEditable(blok)} />
}

export default StoryblokArticleSuggestionSection
